import { render, staticRenderFns } from "./assessPatrolImprStatus.vue?vue&type=template&id=89f10700"
import script from "./assessPatrolImprStatus.vue?vue&type=script&lang=js"
export * from "./assessPatrolImprStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89f10700')) {
      api.createRecord('89f10700', component.options)
    } else {
      api.reload('89f10700', component.options)
    }
    module.hot.accept("./assessPatrolImprStatus.vue?vue&type=template&id=89f10700", function () {
      api.rerender('89f10700', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/riskRegister/assessPatrolImprStatus.vue"
export default component.exports